import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { ECommerce } from "ui/organizms/Onboarding";

const ECommerceApplicataions = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Onboarding | Applications | E-Commerce'
    >
        <ECommerce.ECommerceApplications />
    </Screen>
);

export default memo(ECommerceApplicataions);
